import getCompatibleWeakMap from "./getCompatibleWeakMap";
const CompatibleMap = getCompatibleWeakMap();
let sharedApolloCaches = null;
export function getApolloSharedCaches() {
    if (sharedApolloCaches) {
        return sharedApolloCaches;
    }
    sharedApolloCaches = new CompatibleMap();
    return sharedApolloCaches;
}

//# sourceMappingURL=getApolloSharedCaches.js.map